import React, {PropsWithChildren, ReactNode} from "react";

import {IFieldErrorMessageVariant, IFieldState} from "../../types";
import {FieldLabel} from "../FieldLabel";
import {FieldMessage} from "../FieldMessage";

import {labelStyle} from "./FieldWrapper.module.css";

export interface IFieldWrapperProps extends PropsWithChildren<{
    labelContent?: string | ReactNode;
    htmlFor?: string;
    message?: string;
    fieldState?: IFieldState;
    errorMessageVariant?: IFieldErrorMessageVariant;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    required?: boolean;
    requiredMarkerRight?: boolean;
    requiredMarkerRed?: boolean;
    dataTestId?: string;
    afterChildren?: ReactNode;
}> {}

export const FieldWrapper = (props: IFieldWrapperProps) => {
    const {
        children,
        labelContent,
        htmlFor,
        message,
        fieldState,
        errorMessageVariant = "default",
        onClick,
        required,
        requiredMarkerRight,
        requiredMarkerRed,
        dataTestId,
        afterChildren
    } = props;

    const parseMessage = (message?: string) => {
        if (!message) {
            return null;
        }

        const messageVariant = errorMessageVariant === "alternative" && fieldState === "error" ? "alternative" : "default";

        if (message.includes("\n")) {
            const messages = message.split("\n");
            return messages.map((message) => (
                <FieldMessage key={message} fieldState={fieldState} variant={messageVariant}>
                    {message}
                </FieldMessage>
            ));
        }
        return (
            <FieldMessage fieldState={fieldState} variant={messageVariant}>
                {message}
            </FieldMessage>
        );
    };

    let requiredMarker: ReactNode = "";

    if (required) {
        requiredMarker = requiredMarkerRed ? <span style={{color: "var(--colors-danger)"}}>*</span> : "*";
    }

    return (
        <div className={props.className} onClick={onClick} data-testid={dataTestId}>
            {labelContent && (
                <FieldLabel className={labelStyle} htmlFor={htmlFor}>
                    {requiredMarkerRight ? (
                        <>
                            {labelContent}
                            {requiredMarker}
                        </>
                    ) : (
                        <>
                            {requiredMarker}
                            {labelContent}
                        </>
                    )}
                </FieldLabel>
            )}

            {children}
            {afterChildren}
            {parseMessage(message)}
        </div>
    );
};
import React, {PropsWithChildren, ReactNode} from "react";

import {IFieldErrorMessageVariant, IFieldState} from "../../types";
import {FieldLabel} from "../FieldLabel";
import {FieldMessage} from "../FieldMessage";

import {labelStyle} from "./FieldWrapper.module.css";

export interface IFieldWrapperProps extends PropsWithChildren<{
    labelContent?: string | ReactNode;
    htmlFor?: string;
    message?: string;
    fieldState?: IFieldState;
    errorMessageVariant?: IFieldErrorMessageVariant;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    required?: boolean;
    requiredMarkerRight?: boolean;
    requiredMarkerRed?: boolean;
    dataTestId?: string;
    afterChildren?: ReactNode;
}> {}

export const FieldWrapper = (props: IFieldWrapperProps) => {
    const {
        children,
        labelContent,
        htmlFor,
        message,
        fieldState,
        errorMessageVariant = "default",
        onClick,
        required,
        requiredMarkerRight,
        requiredMarkerRed,
        dataTestId,
        afterChildren
    } = props;

    const parseMessage = (message?: string) => {
        if (!message) {
            return null;
        }

        const messageVariant = errorMessageVariant === "alternative" && fieldState === "error" ? "alternative" : "default";

        if (message.includes("\n")) {
            const messages = message.split("\n");
            return messages.map((message) => (
                <FieldMessage key={message} fieldState={fieldState} variant={messageVariant}>
                    {message}
                </FieldMessage>
            ));
        }
        return (
            <FieldMessage fieldState={fieldState} variant={messageVariant}>
                {message}
            </FieldMessage>
        );
    };

    let requiredMarker: ReactNode = "";

    if (required) {
        requiredMarker = requiredMarkerRed ? <span style={{color: "var(--colors-danger)"}}>*</span> : "*";
    }

    return (
        <div className={props.className} onClick={onClick} data-testid={dataTestId}>
            {labelContent && (
                <FieldLabel className={labelStyle} htmlFor={htmlFor}>
                    {requiredMarkerRight ? (
                        <>
                            {labelContent}
                            {requiredMarker}
                        </>
                    ) : (
                        <>
                            {requiredMarker}
                            {labelContent}
                        </>
                    )}
                </FieldLabel>
            )}

            {children}
            {afterChildren}
            {parseMessage(message)}
        </div>
    );
};
